import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import type { RoleplayStatus } from '../types';

export interface RoleplayStatusOverlayProps {
  status: RoleplayStatus;
  isSmallScreen: boolean;
}

export const RoleplayStatusOverlay: React.FC<RoleplayStatusOverlayProps> = ({
  status,
  isSmallScreen,
}) => {
  if (status !== 'processing' && status !== 'waiting' && status !== 'aiSpeaking') return null;

  return (
    <Box sx={{
      position: 'fixed',
      bottom: isSmallScreen ? '100px' : '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      bgcolor: 'rgba(255, 255, 255, 0.9)',
      borderRadius: '30px',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      zIndex: 1000,
    }}>
      {status === 'processing' && (
        <>
          <CircularProgress size={24} sx={{ mr: 2 }} />
          <Typography>処理中...</Typography>
        </>
      )}
      {status === 'waiting' && (
        <>
          <CircularProgress size={24} sx={{ mr: 2 }} />
          <Typography>AIの応答を待っています...</Typography>
        </>
      )}
      {status === 'aiSpeaking' && (
        <>
          <Box sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            mr: 2,
            animation: 'pulse 1.5s infinite',
            '@keyframes pulse': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0.6 },
              '100%': { opacity: 1 },
            },
          }}>
            AI
          </Box>
          <Typography>AIが話しています...</Typography>
        </>
      )}
    </Box>
  );
};
